export default __webpack_public_path__ + "static/media/paper-plane.6734c926.svg";